export const CREATE_TUTORIAL = "CREATE_TUTORIAL";
export const RETRIEVE_TUTORIALS = "RETRIEVE_TUTORIALS";
export const UPDATE_TUTORIAL = "UPDATE_TUTORIAL";
export const DELETE_TUTORIAL = "DELETE_TUTORIAL";
export const DELETE_ALL_TUTORIALS = "DELETE_ALL_TUTORIALS";

export const CREATE_INVENTORY = "CREATE_INVENTORY";
export const RETRIEVE_INVENTORYS = "RETRIEVE_INVENTORYS";
export const UPDATE_INVENTORY = "UPDATE_INVENTORY";
export const DELETE_INVENTORY = "DELETE_INVENTORY";
export const DELETE_ALL_INVENTORYS = "DELETE_ALL_INVENTORYS";


export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";